import React from "react";
import { connect } from "react-redux";
import {
  uploadIFSCFile,
  uploadFINCAREFile,
  getIFSCData,
  getFincareData,
} from "../../store/actions/fileUploadActions";
import DataTable from "../../components/Table";
import MobilePopUp from "../MobilePopUp/MobilePopUp";
import { hasPermission } from "../Permissions";

class FileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedType: "IFSC",
      pageNo: 1,
      size: 100,
      searchString: "",
      showModal: false,
      fincarePaymentList: {},
      fileType: "Fincare",
    };
  }

  componentDidMount() {
    this.props.getIFSCData(
      this.state.pageNo,
      this.state.size,
      this.state.searchString
    );
  }

  handleChange = (e) => {
    this.setState({
      fileType: e.target.value,
    });
  };

  changeSelection = (type) => {
    if (type !== this.state.selectedType) {
      if (type === "IFSC") {
        this.props.getIFSCData(
          this.state.pageNo,
          this.state.size,
          this.state.searchString
        );
      } else {
        this.props.getFincareData();
      }
      this.setState({
        selectedType: type,
      });
    }
  };

  uploadIFSC = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    this.props.uploadIFSCFile(formData, () => {
      this.props.getIFSCData(
        this.state.pageNo,
        this.state.size,
        this.state.searchString
      );
    });
  };

  uploadFINCARE = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    this.props.uploadFINCAREFile(
      formData,
      this.state.fileType,
      this.state.proposalNo,
      () => {
        this.props.getFincareData();
      }
    );
  };

  triggerUploadCSV = () => {
    document.getElementById("csv-upload").click();
  };

  triggerUploadFin = () => {
    document.getElementById("fincare-upload").click();
  };

  changeSearch = (e) => {
    this.setState({
      searchString: e.target.value,
    });
  };

  searchIFSC = () => {
    this.setState(
      {
        pageNo: 1,
      },
      () => {
        this.props.getIFSCData(
          this.state.pageNo,
          this.state.size,
          this.state.searchString
        );
      }
    );
  };

  nextPage = () => {
    this.setState(
      {
        pageNo: this.state.pageNo + 1,
      },
      () => {
        this.props.getIFSCData(
          this.state.pageNo,
          this.state.size,
          this.state.searchString
        );
      }
    );
  };

  prevPage = () => {
    this.setState(
      {
        pageNo: this.state.pageNo - 1,
      },
      () => {
        this.props.getIFSCData(
          this.state.pageNo,
          this.state.size,
          this.state.searchString
        );
      }
    );
  };

  renderTab = (type, label, hint) => {
    const isSelected = this.state.selectedType === type;

    return (
      <div
        role="button"
        tabIndex={0}
        onClick={() => this.changeSelection(type)}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            this.changeSelection(type);
          }
        }}
        className={`view-count proposal-dashboard__filter-card file-upload-page__tab ${
          isSelected ? "selected" : ""
        }`}
      >
        <span className="proposal-dashboard__filter-label">{label}</span>
        <span className="proposal-dashboard__filter-hint">{hint}</span>
      </div>
    );
  };

  render() {
    const { pageNo } = this.state;
    const { totalPages } = this.props.dashboardData;

    return (
      <div className="proposal-dashboard file-upload-page">
        <div className="proposal-dashboard__header file-upload-page__header">
          <h2 className="proposal-dashboard__title">File Upload</h2>
          <p className="proposal-dashboard__subtitle">
            Upload IFSC bank data and Fincare payment documents
          </p>
        </div>

        <div className="view-options proposal-dashboard__filters file-upload-page__tabs">
          {hasPermission("UPLOAD_IFSC") &&
            this.renderTab("IFSC", "IFSC Data", "Update IFSC records")}
          {hasPermission("UPLOAD_FINCARE") &&
            this.renderTab("FINCARE", "Fincare Docs", "Upload bank documents")}
        </div>

        {this.state.selectedType === "IFSC" && hasPermission("UPLOAD_IFSC") && (
          <>
            <div className="file-upload-page__panel file-upload-page__panel--compact">
              <div className="file-upload-page__controls-row">
                <button
                  type="button"
                  className="file-upload-page__btn file-upload-page__btn--primary"
                  onClick={this.triggerUploadCSV}
                >
                  Upload IFSC File
                </button>
                <input
                  id="ifsc-search"
                  onChange={this.changeSearch}
                  value={this.state.searchString}
                  className="file-upload-page__input file-upload-page__input--search"
                  type="text"
                  placeholder="Search IFSC data"
                  name="searchString"
                  aria-label="Search IFSC data"
                />
                <button
                  type="button"
                  className="file-upload-page__btn file-upload-page__btn--primary"
                  onClick={this.searchIFSC}
                >
                  Search
                </button>
                <input
                  id="csv-upload"
                  className="file-upload-page__file-input"
                  type="file"
                  name="file"
                  accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  onChange={(e) => {
                    if (e.target.files && e.target.files.length) {
                      this.uploadIFSC(e.target.files[0]);
                    }
                  }}
                />
              </div>
            </div>

            {this.props.dashboardData.ifscData && (
              <div className="proposal-dashboard__table-section file-upload-page__table-section">
                <DataTable
                  cellHeaders={["Bank Name", "IFSC Code", "Branch", "MICR"]}
                  data={this.props.dashboardData.ifscData}
                  keys={["bank", "ifsc", "branch", "micr"]}
                  fileName="IFSC Data"
                  addSerialNo={true}
                  showExcelDownload={true}
                  PerPageApiData={false}
                  paginationItems={this.props.dashboardData.ifscData}
                  alwaysShown={false}
                  tableToolbarExtra={
                    <div className="file-upload-page__api-pagination">
                      <span className="file-upload-page__page-info">
                        Page {pageNo} of {totalPages}
                      </span>
                      <button
                        type="button"
                        className="file-upload-page__btn file-upload-page__btn--secondary file-upload-page__page-btn"
                        onClick={this.prevPage}
                        disabled={pageNo <= 1}
                      >
                        Prev
                      </button>
                      <button
                        type="button"
                        className="file-upload-page__btn file-upload-page__btn--secondary file-upload-page__page-btn"
                        onClick={this.nextPage}
                        disabled={pageNo >= totalPages}
                      >
                        Next
                      </button>
                    </div>
                  }
                />
              </div>
            )}
          </>
        )}

        {this.state.selectedType === "FINCARE" &&
          hasPermission("UPLOAD_FINCARE") && (
            <>
              <div className="file-upload-page__panel">
                <div className="file-upload-page__fincare-row">
                  <div className="file-upload-page__field">
                    <label
                      className="file-upload-page__label"
                      htmlFor="fincare-file-type"
                    >
                      Bank type
                    </label>
                    <div className="custom-select-container">
                      <select
                        id="fincare-file-type"
                        className="file-upload-page__select"
                        value={this.state.fileType}
                        onChange={this.handleChange}
                      >
                        <option>Fincare</option>
                        <option>KBL</option>
                        <option>SBM</option>
                        <option>Shivalik</option>
                        <option>Utkarsh</option>
                      </select>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="file-upload-page__btn file-upload-page__btn--primary"
                    onClick={this.triggerUploadFin}
                  >
                    Upload File
                  </button>
                </div>
                <p className="file-upload-page__hint">
                  File upload for Fincare, KBL, SBM, Shivalik, and Utkarsh bank
                </p>
                <input
                  id="fincare-upload"
                  className="file-upload-page__file-input"
                  type="file"
                  name="file"
                  accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  onChange={(e) => {
                    if (e.target.files && e.target.files.length) {
                      this.uploadFINCARE(e.target.files[0]);
                    }
                  }}
                />
              </div>

              {this.props.historyData?.length > 0 && (
                <div className="proposal-dashboard__table-section file-upload-page__table-section">
                  <DataTable
                    cellHeaders={[
                      "File Name",
                      "Upload Date Time",
                      "No. Of Receipt",
                      "File Type",
                    ]}
                    data={this.props.historyData}
                    keys={[
                      "fileName",
                      "uploadDateTime",
                      "noOfReceipts",
                      "fileType",
                    ]}
                    fileName="FINCARE HISTORY DATA"
                    addSerialNo={true}
                    onRowClick={({ fincarePaymentList }) =>
                      this.setState({
                        showModal: true,
                        fincarePaymentList,
                      })
                    }
                    clickColumnIndex={0}
                    showExcelDownload={true}
                    PerPageApiData={false}
                    paginationItems={this.props.historyData}
                    alwaysShown={false}
                  />
                </div>
              )}

              {this.state.showModal && (
                <MobilePopUp
                  onClose={() =>
                    this.setState({ showModal: false, fincarePaymentList: {} })
                  }
                >
                  {!this.state.fincarePaymentList ||
                  !Object.values(this.state.fincarePaymentList).length ? (
                    <div className="file-upload-page__no-data">No Data</div>
                  ) : (
                    <div className="file-upload-page__modal-table">
                      <DataTable
                        cellHeaders={[
                          "Customer Name",
                          "Fincare Account No.",
                          "Proposal No.",
                        ]}
                        data={this.state.fincarePaymentList}
                        keys={["customerName", "fincareAccNo", "proposalNum"]}
                        fileName="FINCARE HISTORY DATA"
                        addSerialNo={true}
                        showExcelDownload={true}
                        PerPageApiData={false}
                        paginationItems={this.state.fincarePaymentList}
                        alwaysShown={false}
                      />
                    </div>
                  )}
                </MobilePopUp>
              )}
            </>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dashboardData: state.dashboardData,
    historyData: state.dashboardData.historyData,
  };
};

export default connect(mapStateToProps, {
  uploadIFSCFile,
  uploadFINCAREFile,
  getIFSCData,
  getFincareData,
})(FileUpload);
